export default "__VITE_PUBLIC_ASSET__a1e6e513__"